// Lib
import React from 'react';
import { useTranslator } from '../../../components/i18n/useTranslator';

/**
 * This component is used when the element type does not have an appropriate modal component.
 */
const NoModalComponentElementModal = () => {
    const translate = useTranslator('modal', 'element.noModalComponent');

    return (
        <div className="NoModalComponentElementModal">
            <h2>{translate('title', 'This element cannot be displayed in full screen')}</h2>
            <div>
                <p>{translate('message', "Sorry, the element you're trying to view cannot be displayed in full screen at this time.")}</p>
            </div>
        </div>
    );
};

NoModalComponentElementModal.propTypes = {};

export default NoModalComponentElementModal;
